import { CircularProgress } from '@llt-frontend/react-material-progress';
import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

//

function ContentLoadingIndicator({ children, className, size, ...forwardedProps }) {
  return (
    <div {...forwardedProps} className={classnames('content-loading-indicator', className)}>
      <CircularProgress {...{ size }} />
      <p className="content-loading-indicator__label">{children}</p>
    </div>
  );
}

ContentLoadingIndicator.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

// Exports
// -------

export default ContentLoadingIndicator;
